import { PaymentMethodsEnum } from '../../../../../views/phone-answering/constants';

export default {
  options: {
    [PaymentMethodsEnum.Cash]: 'Gotówka',
    [PaymentMethodsEnum.Online]: 'Online',
    [PaymentMethodsEnum.InStoreCard]: 'Karta w lokalu',
  },
};
